import {useCallback, useRef, useState} from 'react';
import {SActionBtn, SLowcodeList, STableActions} from "shj-components";
import config from './config.tsx';
import {getTicketsRepairsListPage} from "@/services/customerServices.ts";
import {apiData2Table} from "@/utils/data.ts";
import {modifyModal} from "@/pages/vip/repairList/modify";
import {ViewFile} from "@/pages/vip/repairList/file";
import {filterSerchData} from "@/utils/common.ts";
import {getAuth} from "shj-utils";
import {authDict} from "shj-utils/dist/esm/utils";

export default function() {
  const listRef = useRef<any>();

  const fetchList = (values: { current: number; pageSize: number; query: Record<string, any> }) => {
    return new Promise(async (resolve, reject) => {
      try {
        const {current, pageSize, query} = values;
        const newObj = {...filterSerchData({...query}, ['createdTime'], ['StartWith', 'EndWith'])};
        getTicketsRepairsListPage({params: {pageId: current, pageSize}, data: {...newObj}}).then(res => {
          resolve(apiData2Table(res))
        })
      } catch (e) {
        reject({success: false});
      }
    });
  };
  const getLabel = () => {
    // return api.get('/api-member/labelConfig/page/1/99').then((res: any) => {
    //   return res?.data?.data?.records || [];
    // });
  };
  // 获取下拉
  const getSelection = () => {
    return Promise.resolve({})
    return new Promise((resolve, reject) => {
      Promise.all([
        // getOptions('get', APIS.companyList, {}),
        // getDataDictionaries({ path: 'com.shj.member.domain.enums.BizTypeMenuEnum' }),
        // getLabel(),
      ]).then((resp) => {
        // const listObj = {
        //   companyList: [...resp[0]],
        //   bizOpType: [...resp[1]],
        //   userTypeData: resp[2],
        // };
        // resolve(listObj);

      });
    });
  };

  // 刷新
  const reloadFn = () => {
    const {
      current: {reload},
    } = listRef;
    reload();
  };

  const onEdit = useCallback((record: Record<string, any>) => {
    modifyModal({
      title: '回复',
      fn: reloadFn,
      record,
    });
  }, []);
  const onViewFile = useCallback((record: Record<string, any>) => {
    ViewFile({
      fn: reloadFn,
      record,
    });
  }, []);

  const filterOption = (input: string, option: any) => option.children.indexOf(input) >= 0;

  const extension = {
    request: {fetchList, getSelection},
    events: {filterOption},
    auth: authDict,
    customRender: {
      actionTool(text: any, record: any) {
        return <STableActions>
          <SActionBtn auth="repairBtn" onClick={() => onEdit(record)} primary>
            回复
          </SActionBtn>
          <SActionBtn
              onClick={() => onViewFile(record)}
              primary
              disabled={!Array.isArray(record?.fileList) || record?.fileList?.length == 0}
          >
            查看附件
          </SActionBtn>
        </STableActions>
      },
    },
  };

  return <SLowcodeList searchMode={'group'} config={config} ref={listRef} {...extension} rowKey={'id'}/>;
}
